window._uxa = window._uxa || [];

function csPageEvent(name) {
  try { window._uxa.push(["trackPageEvent", String(name)]); } catch (e) {}
}

function csDvar(key, value) {
  try { window._uxa.push(["trackDynamicVariable", { key: String(key), value: String(value) }]); } catch (e) {}
}
    
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const title = document.getElementById("shopify-pc__banner__body-title");

    if (title) {
      title.textContent = "Cookie Settings 🍪";
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
    
$(document).ready(function () {
    $('.collection-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    dots: true
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.faq-trigger').on('click', function () {
        $(this).toggleClass('active');
        $(this).siblings('.faq-question-outer').find('.faq-question-inner').slideToggle();
    })
    $('.searchToggle').on('click', function (e) {
        e.preventDefault();
        $('#SearchDrawer').fadeIn();
    })

    $('.search-bar__close').on('click', function () {
        $('#SearchDrawer').fadeOut();

    })

    $('.promo-text .title').on('click', function () {
        $(this).siblings('.body').slideToggle();
    })

    $('.main-menu-toggle').on('click', function () {
        const isOpening = !$('.mobile-menu-drawer').is(':visible'); 
        
        // Contentsquare tracking
        csPageEvent(isOpening ? "mobile_menu_open" : "mobile_menu_close");
        if (isOpening) csDvar("menu_version", "new");

        $(this).toggleClass('is-active');
        $('.mobile-menu-drawer').slideToggle();
    
        // Reset to root when opening
        if ($('.mobile-menu-drawer').is(':visible')) {
          var $menu = $('[data-mobile-menu]');
          $menu.find('[data-pane]').removeClass('is-active').hide();
          $menu.find('[data-pane="root"]').addClass('is-active').show();
        }
     
        $('.site-header').toggleClass('is-mobile-menu-open');
        $('.page-header').toggle();
        $('#shopify-chat').toggle();
        $('#omnisend-forms-wrapper').toggle();
        $('#om-campaign-1 .om-tab-wrapper-v2').toggle();
        $('body').toggleClass('o-y-hidden', isOpening);
        $('html').toggleClass('o-y-hidden', isOpening);
    });

});

(function ($) {
    $(document).on('click', '[data-mobile-menu] [data-drilldown-trigger]', function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var target = $(this).attr('data-drilldown-trigger');
      var label = $(this).find('.mobile-menu__label').first().text().trim().slice(0, 80) || "unknown";

      csPageEvent("mobile_menu_drilldown");
      csDvar("menu_version", "new");
      csDvar("menu_target_pane", target);
      csDvar("menu_label", label);

      var $menu = $(this).closest('[data-mobile-menu]');
      $menu.find('[data-pane]').removeClass('is-active').hide();
      $menu.find('[data-pane="'+target+'"]').addClass('is-active').show();

      return false;
    });

    $(document).on('click', '[data-mobile-menu] [data-drilldown-back]', function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      csPageEvent("mobile_menu_back");
      csDvar("menu_version", "new");

      var $menu = $(this).closest('[data-mobile-menu]');

      $menu.find('[data-pane]').removeClass('is-active').hide();
      $menu.find('[data-pane="root"]').addClass('is-active').show();

      return false;
    });
})(jQuery);
  
$(document).on('click', '[data-mobile-menu] a.mobile-menu__row--link, [data-mobile-menu] a.mobile-menu__quicklinks-link', function () {
  var label =
    $(this).find('.mobile-menu__label, .mobile-menu__quicklinks-label').first().text().trim().slice(0, 80) ||
    $(this).text().trim().slice(0, 80) ||
    "unknown";

  var href = $(this).attr('href') || "";

  csPageEvent("mobile_menu_item_click");
  csDvar("menu_version", "new");
  csDvar("menu_item", label);
  csDvar("menu_href", href);
});

// Menu Sticky
// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".site-header");
//   const headerHeight = header.offsetHeight;

//   window.addEventListener("scroll", function () {
//     if (window.scrollY > headerHeight) {
//       header.classList.add("is-fixed");
//       document.body.classList.add("has-fixed-header");
//       //$('.page-header').hide();
//     } else {
//       header.classList.remove("is-fixed");
//       document.body.classList.remove("has-fixed-header");
//     //   $('.page-header').show();
//     }
//   });
// });

const selectVariantByClickingImage = {
    // Create variant images from productJson object
    _createVariantImage: function (product) {
        const variantImageObject = {};
        product.variants.forEach((variant) => {
            if (
                typeof variant.featured_image !== 'undefined' &&
                variant.featured_image !== null
            ) {
                const variantImage = variant.featured_image.src
                    .split('?')[0]
                    .replace(/http(s)?:/, '');
                variantImageObject[variantImage] =
                    variantImageObject[variantImage] || {};
                product.options.forEach((option, index) => {
                    const optionValue = variant.options[index];
                    const optionKey = `option-${index}`;
                    if (
                        typeof variantImageObject[variantImage][optionKey] === 'undefined'
                    ) {
                        variantImageObject[variantImage][optionKey] = optionValue;
                    } else {
                        const oldValue = variantImageObject[variantImage][optionKey];
                        if (oldValue !== null && oldValue !== optionValue) {
                            variantImageObject[variantImage][optionKey] = null;
                        }
                    }
                });
            }
        });
        return variantImageObject;
    },
    _updateVariant: function (event, id, product, variantImages) {
        const arrImage = event.target.src
            .split('?')[0]
            .replace(/http(s)?:/, '')
            .split('.');
        const strExtention = arrImage.pop();
        const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
        const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
        if (typeof variantImages[strNewImage] !== 'undefined') {
            product.variants.forEach((option, index) => {
                const optionValue = variantImages[strNewImage][`option-${index}`];
                if (optionValue !== null && optionValue !== undefined) {
                    const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
                    const options = selects[index].options;
                    for (let option, n = 0; (option = options[n]); n += 1) {
                        if (option.value === optionValue) {
                            selects[index].selectedIndex = n;
                            selects[index].dispatchEvent(new Event('change'));
                            break;
                        }
                    }
                }
            });
        }
    },
    _selectVariant: function() {
        const productJson = document.querySelectorAll('[id^=ProductJson-');
        if (productJson.length > 0) {
            productJson.forEach((product) => {
                const sectionId = product.id.replace("ProductJson-", "shopify-section-");
                const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/products/"]');
                if (thumbnails.length > 1) {
                    const productObject = JSON.parse(product.innerHTML);
                    const variantImages = this._createVariantImage(productObject);
                    // need to check variants > 1
                    if (productObject.variants.length > 1) {
                        thumbnails.forEach((thumbnail) => {
                            thumbnail.addEventListener('click', (e) =>
                                this._updateVariant(e, sectionId, productObject, variantImages),
                            );
                        });
                    }
                }
            });
        }
    },
};
if (document.readyState !== 'loading') {
    selectVariantByClickingImage._selectVariant();
} else {
    // document.addEventListener(
    //     'DOMContentLoaded',
    //     selectVariantByClickingImage._selectVariant(),
    // );
    document.addEventListener(
        'DOMContentLoaded',
        () => selectVariantByClickingImage._selectVariant()
    );
}

class Accordion {
    constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="content"> element
        this.content = el.querySelector('.content');

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    }

    shrink() {
        // Set the element as "being closed"
        this.isClosing = true;

        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflown hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
    }
}

console.log(document.querySelectorAll('details'));
document.querySelectorAll('details').forEach((el) => {
    console.log(el)
    new Accordion(el);
});
